<template>
  <tr class="child-row" :id="`${row.employee_id}`" :data-project_id="`${row.project_id}`">
    <td
      class="issue-cell"
      :style="{ paddingLeft: `${(row.level || 0) * 16}px` }"
    >
      <div class="issue-content">
        <a-tooltip :title="row.label">
          <div class="issue-text">{{ row.label }}</div>
        </a-tooltip>
        <div v-if="row.meta" class="meta">{{ row.meta }}</div>
      </div>
    </td>

    <td class="sum-cell">{{ formatHour(row.total) }}</td>

    <td
      v-for="day in dayColumns"
      :key="`${row.id}-${day.date}`"
      :class="['log-cell', { 'weekend-cell': day.dayName === 'Bảy' || day.dayName === 'CN' }]"
    >
      <div
        class="log-value"
        @click="handleCellClick(day, row.values ? row.values[day.date] : null, $event)"
        :style="{ cursor: canClick ? 'pointer' : 'default' }"
      >
        <template v-if="row.values && row.values[day.date]">
          <LogworkHourBar :hours="row.values[day.date]" :viewMode="viewMode" />
          <span class="hours">{{ formatHour(row.values[day.date]) }}</span>
        </template>
      </div>
    </td>
  </tr>
</template>

<script>
import LogworkHourBar from "./LogworkHourBar.vue";

export default {
  name: "LogworkChildRow",
  components: {
    LogworkHourBar
  },
  props: {
    row: { type: Object, required: true },
    dayColumns: { type: Array, required: true },
    viewMode: { type: String, default: 'day' }
  },
  computed: {
    currentEmployeeId() {
      const account = this.$store?.getters?.["auth/account"];
      // account.id is used widely as employee identifier in this app
      return account ? String(account.id) : null;
    },
    canClick() {
      // Allow clicking if current user is this row's employee OR project manager
      const rowEmployeeId = this.row && this.row.employee_id != null ? String(this.row.employee_id) : null;
      const rowManagerId = this.row && this.row.project_manager_id != null ? String(this.row.project_manager_id) : null;
      const current = this.currentEmployeeId;
      if (!current) return false;
      if (rowEmployeeId && rowEmployeeId === current) return true;
      if (rowManagerId && rowManagerId === current) return true;
      return false;
    }
  },
  methods: {
    formatHour(value) {
      if (!value) return 0;
      const hours = typeof value === "object" ? value.hours : value;
      return Number(hours.toFixed(1))
        .toString()
        .replace(/\.0$/, "");
    },
    handleCellClick(day, value, e) {
      if (!this.canClick) return;
      if (value && typeof value === "object" && value.id) {
        this.$emit("view-detail", value.id);
        return;
      }

      // Get project_id from DOM attribute (requested behavior)
      const projectIdFromDataset =
        (e &&
          e.currentTarget &&
          e.currentTarget.closest &&
          e.currentTarget.closest("tr") &&
          e.currentTarget.closest("tr").dataset &&
          e.currentTarget.closest("tr").dataset.project_id) ||
        (this.$el && this.$el.dataset ? this.$el.dataset.project_id : null) ||
        null;

      this.$emit("create-logwork", {
        date: day.date,
        rowId: this.row?.id || null,
        employee_id: this.$el && this.$el.id ? this.$el.id : null,
        project_id: projectIdFromDataset
      });
    }
  }
};
</script>

<style scoped>
.child-row {
  height: 40px;
  border-bottom: 1px solid #f0f0f0;
}

.child-row:hover {
  background-color: #fafafa;
}

.issue-cell {
  padding: 0 16px;
  border-right: 1px solid #f0f0f0;
  vertical-align: middle;
  font-size: 13px;
  color: #262626;
  max-width: 100px;
}

.issue-content {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}

.issue-text {
  white-space: normal;
  word-break: break-word;
  text-align: left;
}

.meta {
  color: #8c8c8c;
  font-size: 12px;
}

.sum-cell {
  text-align: center;
  font-weight: 600;
  color: #262626;
  border-right: 1px solid #f0f0f0;
  vertical-align: middle;
  font-size: 13px;
  width: 50px;
}

.log-cell {
  border-right: 1px solid #f0f0f0;
  vertical-align: middle;
  padding: 0;
  height: 52px;
  width: 52px; /* Adjust based on design */
  position: relative;
}

.log-value {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 100%;
}

.hours {
  font-size: 13px;
  color: #262626;
  z-index: 1;
}

::v-deep td.log-cell.weekend-cell {
  background-color: #F6F6F6 !important;
}
</style>
